import React, { useCallback, useState, useEffect } from "react";
import {
  DropZone,
  Page,
  FormLayout,
  TextField,
  Card,
  PageActions,
  Stack,
  Thumbnail,
  Caption,
  TextStyle,
  Loading,
  InlineError,
  Checkbox,
  RadioButton,
  Select,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import history from "../../Assets/Lib/history";
import MultiSelect from "react-multi-select-component";
import Cookies from "js-cookie";
import JoditEditor from "jodit-react";
import { useMemo } from "react";
const Add = () => {
  var PromiseAll = require("promises-all");
  const [titleEnValue, setTitleEnValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.name
      ? JSON.parse(Cookies.get("houna-wellness")).name
      : ""
  );
  const handleChangeTitleEn = useCallback((newValue) => {
    setTitleEnValue(newValue);
    setTitleError("");
  }, []);
  const [titleArValue, setTitleArValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.name_ar
      ? JSON.parse(Cookies.get("houna-wellness")).name_ar
      : ""
  );
  const handleChangeTitleAr = useCallback((newValue) => {
    setTitleArValue(newValue);
    setTitleError("");
  }, []);
  const [titleError, setTitleError] = useState("");
  const [emailValue, setEmailValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.email
      ? JSON.parse(Cookies.get("houna-wellness")).email
      : ""
  );
  const handleChangeEmail = useCallback((newValue) => {
    setEmailValue(newValue);
  }, []);
  const [phoneNumberEnValue, setPhoneNumberEnValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.phone_number
      ? JSON.parse(Cookies.get("houna-wellness")).phone_number
      : ""
  );
  const handleChangePhoneNumberEn = useCallback((newValue) => {
    setPhoneNumberEnValue(newValue);
  }, []);
  const [phoneNumberArValue, setPhoneNumberArValue] = useState("");
  const handleChangePhoneNumberAr = useCallback((newValue) => {
    setPhoneNumberArValue(newValue);
  }, []);
  const [addressEnValue, setAddressEnValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.office_address
      ? JSON.parse(Cookies.get("houna-wellness")).office_address
      : ""
  );
  const handleChangeAddressEn = useCallback((newValue) => {
    setAddressEnValue(newValue);
  }, []);
  const [addressArValue, setAddressArValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.office_address_ar
      ? JSON.parse(Cookies.get("houna-wellness")).office_address_ar
      : ""
  );
  const handleChangeAddressAr = useCallback((newValue) => {
    setAddressArValue(newValue);
  }, []);
  const [textEnValue, setTextEnValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.biography
      ? JSON.parse(Cookies.get("houna-wellness")).biography
      : ""
  );
  const handleChangeTextEn = useCallback((newValue) => {
    setTextEnValue(newValue);
    setTextError("");
  }, []);
  const [textArValue, setTextArValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.biography_ar
      ? JSON.parse(Cookies.get("houna-wellness")).biography_ar
      : ""
  );
  const handleChangeTextAr = useCallback((newValue) => {
    setTextArValue(newValue);
    setTextError("");
  }, []);
  const [textError, setTextError] = useState("");
  const [profileEnValue, setProfileEnValue] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.services
      ? JSON.parse(Cookies.get("houna-wellness")).services
      : ""
  );
  const handleChangeProfileEn = (newValue) => {
    setProfileEnValue(newValue);
    setProfileError("");
  };
  const [profileArValue, setProfileArValue] = useState("");
  const handleChangeProfileAr = (newValue) => {
    setProfileArValue(newValue);
    setProfileError("");
  };
  const [profileError, setProfileError] = useState(
    Cookies.get("houna-wellness") &&
      JSON.parse(Cookies.get("houna-wellness"))?.services_ar
      ? JSON.parse(Cookies.get("houna-wellness")).services_ar
      : ""
  );
  const [isSaving, setIsSaving] = useState(false);
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const [desktopImagePreview, setDesktopImagePreview] = useState(
    Cookies.get("houna-lead") && JSON.parse(Cookies.get("houna-lead"))?.image
      ? JSON.parse(Cookies.get("houna-lead")).image
      : ""
  );
  const [desktopImageError, setDesktopImageError] = useState("");
  const [files, setFiles] = useState([]);
  const handleDropZone = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const fileUpload = !files.length && <DropZone.FileUpload />;
  let uploadedFiles = files.length > 0 && (
    <Stack alignment="center">
      <Thumbnail
        size="small"
        alt={files[files.length - 1].name}
        source={
          validImageTypes.indexOf(files[files.length - 1].type) > 0
            ? window.URL.createObjectURL(files[files.length - 1])
            : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
        }
      />
      <div>
        {files[files.length - 1].name}{" "}
        <Caption>{files[files.length - 1].type} bytes</Caption>
      </div>
    </Stack>
  );
  const sendImage = (files) => {
    setDesktopImagePreview(
      validImageTypes.indexOf(files[files.length - 1].type) > 0
        ? window.URL.createObjectURL(files[files.length - 1])
        : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
    );
    setDesktopImageError("");
  };
  const [checkedShow, setCheckedShow] = useState(true);
  const handleChangeShow = useCallback(
    (newChecked) => setCheckedShow(newChecked),
    []
  );

  const [summaryError, setSummaryError] = useState("");
  const [visitValue, setVisitValue] = useState("");
  const handleChangeVisit = useCallback(
    (newValue) => setVisitValue(newValue),
    []
  );
  const [optionsCountries, setOptionsCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [checkedOnline, setCheckedOnline] = useState(false);
  const handleChangeOnline = useCallback(
    (newChecked) => setCheckedOnline(newChecked),
    []
  );
  useEffect(() => {
    Cookies.get("houna-wellness") &&
      console.log(JSON.parse(Cookies.get("houna-wellness")));
    axios
      .get(`/admin/countries`)
      .then((response) => {
        setIsSaving(false);
        response?.data &&
          setOptionsCountries(
            response.data.map((item, index) => {
              return {
                label: item.name[Object.keys(item.name)[0]],
                value: String(item.id),
                key: String(item.id),
              };
            })
          );
        if (Cookies.get("houna-wellness")) {
          JSON.parse(Cookies.get("houna-wellness"))?.country?.split(",")
            .length &&
            setSelectedCountries(
              JSON.parse(Cookies.get("houna-wellness"))
                .country.split(",")
                .reduce((result, item, i) => {
                  if (findArrayElementByName(response.data, item)) {
                    result.push({
                      label: item,
                      value: String(
                        findArrayElementByName(response.data, item).id
                      ),
                    });
                  }
                  return result;
                }, [])
            );
        }
      })

      .catch((err) => console.log(err));
  }, []);
  const editorConfig = useMemo(
    () => ({
      readonly: false,
      toolbarAdaptive: false, // disable auto-hiding toolbar
      toolbarSticky: false,
      toolbarButtonSize: "middle",
      buttons: ["bold", "italic", "underline", "|", "ul", "ol"],
      removeButtons: ["link", "source", "fullsize"],
      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: false,
      showStatusbar: false,
      enableDragAndDropFileToEditor: false,
      spellcheck: false,
      askBeforePasteHTML: false,
      placeholder: "",
    }),
    []
  );
  return (
    <Page title="Add Item" breadcrumbs={[{ url: "/admin/wellness-centers" }]}>
      {isSaving ? <Loading /> : null}
      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <FormLayout>
              <TextStyle variation="strong">Name En</TextStyle>
              <TextField value={titleEnValue} onChange={handleChangeTitleEn} />
            </FormLayout>
            <FormLayout>
              <TextStyle variation="strong">Name Ar</TextStyle>
              <TextField value={titleArValue} onChange={handleChangeTitleAr} />
            </FormLayout>
          </FormLayout.Group>
          <InlineError message={titleError} />
          <FormLayout.Group>
            <FormLayout>
              <TextStyle variation="strong">Phone Number En</TextStyle>
              <TextField
                value={phoneNumberEnValue}
                onChange={handleChangePhoneNumberEn}
              />
            </FormLayout>
            <FormLayout>
              <TextStyle variation="strong">Phone Number Ar</TextStyle>
              <TextField
                value={phoneNumberArValue}
                onChange={handleChangePhoneNumberAr}
              />
            </FormLayout>
          </FormLayout.Group>
          <FormLayout.Group>
            <FormLayout>
              <TextStyle variation="strong">Address En</TextStyle>
              <TextField
                value={addressEnValue}
                onChange={handleChangeAddressEn}
              />
            </FormLayout>
            <FormLayout>
              <TextStyle variation="strong">Address Ar</TextStyle>
              <TextField
                value={addressArValue}
                onChange={handleChangeAddressAr}
              />
            </FormLayout>
          </FormLayout.Group>
          <TextStyle variation="strong">Email</TextStyle>
          <TextField value={emailValue} onChange={handleChangeEmail} />
          <FormLayout.Group>
            <FormLayout>
              <TextStyle variation="strong">Services En</TextStyle>
              <TextField
                value={textEnValue}
                onChange={handleChangeTextEn}
              ></TextField>
            </FormLayout>
            <FormLayout>
              <TextStyle variation="strong">Services Ar</TextStyle>
              <TextField
                value={textArValue}
                onChange={handleChangeTextAr}
              ></TextField>
            </FormLayout>
          </FormLayout.Group>
          <InlineError message={summaryError} />
          <TextStyle variation="strong">Visit</TextStyle>
          <TextField
            value={visitValue}
            onChange={handleChangeVisit}
            autoComplete="off"
          />
          <FormLayout.Group>
            <FormLayout>
              <TextStyle variation="strong">Profile En</TextStyle>
              <JoditEditor
                value={profileEnValue}
                onChange={handleChangeProfileEn}
                config={editorConfig}
              />
            </FormLayout>
            <FormLayout>
              <TextStyle variation="strong">Profile Ar</TextStyle>
              <JoditEditor
                value={profileArValue}
                onChange={handleChangeProfileAr}
                config={editorConfig}
              />
            </FormLayout>
          </FormLayout.Group>
          <InlineError message={profileError} />

          <FormLayout.Group>
            <FormLayout>
              <TextStyle variation="strong">Image</TextStyle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={desktopImagePreview ? desktopImagePreview : ""}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone onDrop={handleDropZone} onDropAccepted={sendImage}>
                    {uploadedFiles}
                    {fileUpload}
                  </DropZone>
                </div>
              </div>
              <InlineError message={desktopImageError} />
            </FormLayout>
          </FormLayout.Group>
          <TextStyle variation="strong">Countries</TextStyle>
          <MultiSelect
            options={optionsCountries}
            value={selectedCountries}
            onChange={setSelectedCountries}
            labelledBy="Please select a country"
          />
          <Checkbox
            label="Is Purely Online"
            checked={checkedOnline}
            onChange={handleChangeOnline}
          />
          <Checkbox
            label="Is Active"
            checked={checkedShow}
            onChange={handleChangeShow}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
    </Page>
  );

  function handleSave() {
    if (!titleEnValue && !titleArValue) {
      setTitleError("Please enter a name");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      visitValue && form_data.append("website", visitValue);
      titleEnValue && form_data.append("name[en]", titleEnValue);
      titleArValue && form_data.append("name[ar]", titleArValue);
      textEnValue && form_data.append("summary[en]", textEnValue);
      textArValue && form_data.append("summary[ar]", textArValue);
      profileEnValue && form_data.append("profile[en]", profileEnValue);
      profileArValue && form_data.append("profile[ar]", profileArValue);
      if (files.length) {
        form_data.append("image", files[files.length - 1]);
      } else if (
        Cookies.get("houna-wellness") &&
        JSON.parse(Cookies.get("houna-wellness"))?.image
          ? JSON.parse(Cookies.get("houna-wellness")).image
          : ""
      ) {
        form_data.append("image", JSON.parse(Cookies.get("houna-lead")).image);
      }
      form_data.append("show", checkedShow ? 1 : 0);
      form_data.append("highlighted", 1);
      form_data.append("order", 1);
      addressEnValue && form_data.append("address[en]", addressEnValue);
      addressArValue && form_data.append("address[ar]", addressArValue);
      phoneNumberEnValue && form_data.append("phone[en]", phoneNumberEnValue);
      phoneNumberArValue && form_data.append("phone[ar]", phoneNumberArValue);
      emailValue && form_data.append("email", emailValue);
      selectedCountries.length &&
        selectedCountries.forEach((selected, index) =>
          form_data.append(`country_id[${index}]`, selected.value)
        );
      form_data.append("online", checkedOnline ? 1 : 0);
      axios
        .post("/admin/wellness-center", form_data)
        .then((res) => {
          if (res.status == 200) {
            history.push("/admin/wellness-centers");
          }
        })
        .catch((err) => console.log(""));
    }
  }
  function findArrayElementByName(array, value) {
    return array.find((element, index) => {
      return element.name.en.toLowerCase() == value.toLowerCase();
    });
  }
};
export default Add;
